import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Delivering Vercel-Style Developer Experience with Kubernetes and GitLab`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/post/build-platform-kubernetes-gitlab/0-introduction"
        }}>{`Introduction: Why build your own developer platform?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/post/build-platform-kubernetes-gitlab/1-cluster-setup"
        }}>{`Part I: Cluster setup`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/post/build-platform-kubernetes-gitlab/2-pipeline-configuration"
        }}>{`Part II: GitLab pipeline and CI/CD configuration`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/post/build-platform-kubernetes-gitlab/3-containers-setup"
        }}>{`Part III: Applications and the Dockerfile`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/post/build-platform-kubernetes-gitlab/4-kubernetes-manifests"
        }}>{`Part IV: Kubernetes manifests`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      